exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button{margin-bottom:20px}mat-form-field{width:100%}", ""]);

// exports
